































import { Component, Vue, Watch, Prop } from 'vue-property-decorator'
import CompareSlider from '../ui/CompareSlider.vue'
import '@/icons/coating-scratch'
import '@/icons/coating-reflection'
import '@/icons/coating-dirt'
import '@/icons/coating-water'
import '@/icons/coating-static'

@Component({
  components: {
    CompareSlider
  }
})
export default class TabCoating extends Vue {
  public $refs!: {
    slider: CompareSlider
  }
  @Prop({ default: false }) private show!: boolean
  private backgroundImage: string = require('@/assets/images/tabs/coating/background.png')
  private coverImage: string = require('@/assets/images/tabs/coating/coating-scratch-cover.png')
  private options: Array<{
    id: number,
    title: string,
    cover: string,
    icon: string,
    selected: boolean
  }> = [
    {
      id: 0,
      title: 'tab_coating_scratch',
      cover: require('@/assets/images/tabs/coating/coating-scratch-cover.png'),
      icon: 'coating-scratch',
      selected: true
    },
    {
      id: 1,
      title: 'tab_coating_reflection',
      cover: require('@/assets/images/tabs/coating/coating-reflection-cover.png'),
      icon: 'coating-reflection',
      selected: false
    },
    {
      id: 2,
      title: 'tab_coating_dirt',
      cover: require('@/assets/images/tabs/coating/coating-dirt-cover.png'),
      icon: 'coating-dirt',
      selected: false
    },
    {
      id: 3,
      title: 'tab_coating_water',
      cover: require('@/assets/images/tabs/coating/coating-water-cover.png'),
      icon: 'coating-water',
      selected: false
    },
    {
      id: 4,
      title: 'tab_coating_static',
      cover: require('@/assets/images/tabs/coating/coating-antistatic-cover.png'),
      icon: 'coating-static',
      selected: false
    }
  ]
  @Watch('show')
  private onShowChanged (val: boolean, oldVal: boolean) {
    if (val !== oldVal) {
      this.$refs.slider.forceUpdate()
    }
  }
  private selectOption (index: number) {
    for (let i = 0; i < this.options.length; i++) {
      if (index === i) {
        this.options[i].selected = true
        this.coverImage = this.options[i].cover
      } else {
        this.options[i].selected = false
      }
    }
  }
}
